import { types } from "mobx-state-tree"

const RallySafeClass = types.model('RallySafeClass', {
    id: types.identifierNumber,
    name: types.string,
})

export default RallySafeClass
